import { List, Map} from 'immutable'
import * as actionTypes from '../actions/actionTypes'

const initialState = Map({
  buttons: List([]),
})

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.SET_MENU:
      return state.set('buttons', List(action.payload.buttons))
    case actionTypes.RESET_CHAT:
      return initialState
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/ChatWidget/store/reducers/menuReducer.js